import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HostBackend } from '../HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterParkAndUnivers } from '../../Components/Public/Filters/FilterParkAndUnivers.js';
import { History } from '../../Pages/Public/History.js';
import { NotFound } from '../../Pages/Public/NotFound.js';

export const RouteHistory = () => {
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [parks, setParks] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasParks = await fetch(`${backend}/nav/parks`, GetHeaders(guest));
            const parks = await datasParks.json();
            setParks(parks);
        };
        fetchData();
    }, [backend, guest]);
    if (parks.err) window.location.href = '/';
    const navParks = FilterParkAndUnivers(parks);
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/historique" element={<History navParks={navParks} />} />
                <Route path="*" element={<NotFound navParks={navParks} />} />
            </Routes>
        </BrowserRouter>
    )
}
